import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys, IInfoBlockItem } from "shared/types";

export const getInfoBlockItemKey = (venueId: string, type: IInfoBlockItem) => {
  switch (type) {
    default:
    case IInfoBlockItem.contact: {
      return `${API_ENDPOINTS.VENUE(venueId)}/${IDataKeys.contact}`;
    }
    case IInfoBlockItem.place: {
      return `${API_ENDPOINTS.VENUE(venueId)}/${IDataKeys.place}`;
    }
    case IInfoBlockItem.file: {
      return `${API_ENDPOINTS.VENUE(venueId)}/${IDataKeys.file}`;
    }
    case IInfoBlockItem.image: {
      return `${API_ENDPOINTS.VENUE(venueId)}/${IDataKeys.image}`;
    }
  }
};
